module.exports = __webpack_public_path__ + "static/media/sello_sp_delonia.0e5c1abb.png";